import React, { FunctionComponent, useState } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import {
  ModalBackdrop,
  ModalWrapper,
  Title,
  TitleText,
  CloseButton,
  Body,
  ParagraphsWrapper,
  Paragraph,
  LinkToReviews,
} from "./styles/modal-styles";

export interface IPendingReviewsDashboardModalProps {
  pendingReviewsCount?: number;
}

const PendingReviewsDashboardModal: FunctionComponent<
  IPendingReviewsDashboardModalProps
> = ({ pendingReviewsCount }) => {
  const [modalActive, dismissModal] = useState(true);
  const handleCloseButton = () => dismissModal(!modalActive);

  if (modalActive) {
    return (
      <ModalBackdrop>
        <ModalWrapper data-test-id="pending-reviews-dashboard-modal">
          <Title>
            <TitleText>Leave a review</TitleText>
            {/* Temporary hidding of the close button to force employers to leave reviews. */}
            {/* <CloseButton
              onClick={handleCloseButton}
              data-test-id="close-pending-reviews-dashboard-modal-button"
            >
              <FontAwesomeIcon icon={faTimes} />
            </CloseButton> */}
          </Title>
          <Body>
            <ParagraphsWrapper>
              <Paragraph>
                Great news! You&apos;ve made placements using our wonderful
                agencies. To make the marketplace the best it can be, we would
                love it if you left a review for the successful agencies.
              </Paragraph>
              <Paragraph>
                Leaving reviews helps other employers understand the quality of
                our agencies, and will also be used as a metric in generating
                your HH rating.
              </Paragraph>
              <Paragraph center>
                You have{" "}
                <strong>
                  {" "}
                  {pendingReviewsCount}{" "}
                  {pendingReviewsCount === 1 ? "review" : "reviews"}
                </strong>{" "}
                outstanding.
              </Paragraph>
              <Paragraph center>
                Click{" "}
                <LinkToReviews href="/employer/pending_reviews#/">
                  here
                </LinkToReviews>{" "}
                to leave a review.
              </Paragraph>
            </ParagraphsWrapper>
          </Body>
        </ModalWrapper>
      </ModalBackdrop>
    );
  }
  return null;
};

PendingReviewsDashboardModal.propTypes = {
  pendingReviewsCount: PropTypes.number,
};

PendingReviewsDashboardModal.defaultProps = {
  pendingReviewsCount: null,
};

export default PendingReviewsDashboardModal;
